<template>
  <div class="file-card">

    <div class="file-header d-flex align-items-center">
      <div class="d-flex align-items-center flex-grow-1">
        <div class="me-3">
          <material-avatar
            :img="contact.image"
            :alt="contact.name"
            :color="contact.color"
            size="md"
            shadow="sm"
            circular
          />
        </div>
        <div class="text-truncate">
          <div class="d-flex align-items-center gap-2">
            <p class="file-title text-sm text-capitalize mb-0 text-truncate">{{ contact.name }}</p>
            <span v-if="!contact.publicKey" class="badge bg-light text-muted border" style="font-size: 0.65rem; font-weight: normal;">
              Unverified
            </span>
          </div>
          <p class="file-meta text-xs mb-0 text-truncate">{{ contact.email }}</p>
        </div>
      </div>
      
      <div class="ms-auto">
        <div class="dropdown">
          <button
            class="btn"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            @click.stop
          >
            <FontAwesomeIcon icon="fa-solid fa-ellipsis-vertical" />
          </button>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="actionsDropdown">
              <li>
              <a class="dropdown-item" href="#"  @click="editContactClicked">
                <FontAwesomeIcon icon="fa-solid fa-pencil" class="me-2"/> Edit
              </a>
            </li>
            <li v-if="contact.publicKey">
              <a class="dropdown-item" href="#" @click="shareWithContactClicked">
                <FontAwesomeIcon icon="fa-solid fa-share-nodes" class="me-2" /> Share Files
              </a>
            </li>
            <!-- <li>
              <a class="dropdown-item" href="#">
                <FontAwesomeIcon icon="fa-solid fa-envelope" class="me-2" /> Email
              </a>
            </li> -->
            <li>
              <a class="dropdown-item text-danger" href="#" @click="deleteContactClicked">
                <FontAwesomeIcon icon="fa-solid fa-trash" class="me-2" /> Delete
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col d-flex justify-content-end">
        <button
          v-if="contact.publicKey"
          class="btn font-weight-light text-capitalize mx-3"
          aria-label="Share file" style="border: 0.5px solid rgb(229, 231, 235); color: black; text-decoration:none;"
          @click="shareWithContactClicked"
        >
          <FontAwesomeIcon icon="fa-solid fa-share-nodes" style="font-size: 14px;" /> &nbsp; Share files
        </button>
        <button
          v-if="!contact.publicKey && !contact.invited"
          class="btn font-weight-light text-capitalize bg-accent"
          aria-label="Invite Contact" style="border: 0.5px solid rgb(229, 231, 235); color: black; text-decoration:none;"
          @click="inviteContactClicked"
        >
          <FontAwesomeIcon icon="fa-solid fa-envelope" style="font-size: 14px;" /> &nbsp; Invite
        </button>
        <button
          v-if="!contact.publicKey && contact.invited"
          class="btn font-weight-light text-capitalize"
          disabled
          aria-label="Contact invited" style="border: 0.5px solid rgb(229, 231, 235); color: #6c757d; background-color: #f8f9fa; text-decoration:none; cursor: not-allowed;"
        >
          <FontAwesomeIcon icon="fa-solid fa-envelope" style="font-size: 14px;" /> &nbsp; Invited
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import MaterialAvatar from '@/components/ui/MaterialAvatar';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'ContactCard',
  components: {
    MaterialAvatar,
    FontAwesomeIcon,
  },
  props: {
      contact: {
        type: Object,
        required: true
      },
  },
  emits: [
    'open-edit-contact-modal',
    'open-share-files-modal',
    'open-delete-contact-modal',
    'contact-invited'
  ],
  methods: {
    editContactClicked() {
      this.$emit('open-edit-contact-modal');
    },

    shareWithContactClicked() {
      this.$emit('open-share-files-modal', this.contact);
    },

    inviteContactClicked() {
      this.$emit('contact-invited', this.contact);
    },

    deleteContactClicked() {
      this.$emit('open-delete-contact-modal');
    },
  }
}
</script>

<style scoped>
/* Card container */
.file-card {
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 8px;
  border: 1px solid rgb(229, 231, 235);
  padding: 10px;
  color: #333;
  overflow: visible;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  z-index: $zindex-main;
}

/* .file-card:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
} */

.file-meta {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.file-title {
  margin-bottom: 2px;
}

.dropdown-menu {
  z-index: $zindex-dropdown;
}
</style>
